import { ApiError } from "@/lib/errors"

/** Where every "this review isn't here" state sends a staff reader. */
export const REVIEW_QUEUE_PATH = "/reviews"

/**
 * The server says this review is not there for this reader: it never existed,
 * or it sits outside a client's engagement (a 403 reads the same, so a client
 * cannot probe for ids). Retrying will not change either answer, so the way
 * out is the queue, never the review itself.
 */
export function isReviewGone(error: unknown): boolean {
  return error instanceof ApiError && (error.isNotFound || error.isForbidden)
}
